import { useEffect } from "react";

const useOnClickOutside = (refs, handler = () => {}) => {
  // Normalize to array
  const refArray = Array.isArray(refs) ? refs : [refs];

  useEffect(() => {
    const listener = (event) => {
      if (event.defaultPrevented) return;

      const nodes = refArray.flatMap((ref) => {
        if (!ref) return [];
        const current = ref.current;
        if (Array.isArray(current)) return current.filter(Boolean);
        return current ? [current] : [];
      });

      // If any node contains target, it's an inside click
      const clickedInside = nodes.some(
        (node) => node && node.contains && node.contains(event.target)
      );

      if (!clickedInside) {
        handler(event);
      }
    };

    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);

    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [refArray, handler]);
};

export default useOnClickOutside;
